// extracted by mini-css-extract-plugin
export default {"ingredientitem":"IngredientContent_ingredientitem__DGiVX","image":"IngredientContent_image__OdIhB"};